import '../dialogs.mobile.scss';
import './editUserDialog.mobile.scss';
import 'react-international-phone/style.css';

import * as React from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { PhoneInput } from 'react-international-phone';

import * as StM from '../../../models/store';
import * as ActM from '../../../actions';
import * as SrvM from '../../../services';
import { ModalMobile, InputSearchMobile, Field, FormError } from '../../../components';
import DatePickerMobile from '../../../components/datepicker.mobile';
import Strings from "../../../models/store/strings";

interface IEditUserDialogProps {
    isShown: boolean;
    user: StM.IUserStoreState;
    club: StM.IClubStoreState;
    isAuth: boolean;

    showSpinner: () => any;
    hideSpinner: () => any;
    closeBookDialog: () => void;
    save: (profile: StM.IUserManagableStoreState) => Promise<any>;
    closeAlert: () => void;
}

interface IEditUserDialogState {
    profile?: StM.IUserManagableStoreState;
    errors: any;
}

class EditUserMobile extends React.Component<IEditUserDialogProps, IEditUserDialogState> {
    private utils = new SrvM.Utils();
    private validator = new SrvM.ValidationService();
    private formValidator = new SrvM.FormValidationService();
    private authSrv = new SrvM.AuthenticationService();

    phoneCursorPositions: number;
    constructor(props: IEditUserDialogProps) {
        super(props);
        this.state = {
            profile: this.getProfile(this.props.user)
            , errors: null
        };
    }

    private getProfile(user: StM.IUserStoreState) {
        let profile = new StM.UserManagableStoreState(user);
        (profile && !profile.skill) && (profile.skill = StM.UserSkill.Beginner);
        if(user && !user.dateOfBirth) profile.dateOfBirth = null;
        return profile;
    }

    private sex = [
        { key: 1, value: StM.Gender.Male },
        { key: 2, value: StM.Gender.Female }
    ];

    private skills = [
        { key: 1, value: StM.UserSkill.Beginner, title: StM.DisplayUserSkill.Beginner },
        { key: 2, value: StM.UserSkill.Intermediate, title: StM.DisplayUserSkill.Intermediate },
        { key: 3, value: StM.UserSkill.Advanced, title: StM.DisplayUserSkill.Advanced }
    ];

    componentDidUpdate(prevProps: IEditUserDialogProps) {
        const isShowChanged = !prevProps.isShown && this.props.isShown;
        const isAuthChanged = this.props.isShown && prevProps.isAuth && !this.props.isAuth;

        if (isAuthChanged || (this.props.user && this.authSrv.isInRole(StM.Roles.GroupAccount, this.props.user))) {
            this.props.closeBookDialog();
            return;
        }

        if (isShowChanged) {
            this.setState({ profile: this.getProfile(this.props.user) });
        } else if (prevProps.isShown && !this.props.isShown) {
            this.setState({ errors: null });
        }
    }

    public render() {
        if (this.props.isShown) {
            let profile = this.state.profile;
            let sex: any = _.find(this.sex, { value: profile.gender });
            let skillString = this.utils.getSkill(profile.skill);

            let skill: any = _.find(this.skills, { value: profile.skill });
            if (sex) sex = sex.key;
            else sex = 0;
            if (skill) skill = skill.key;
            else skill = this.skills[0].key;

            return (
                <ModalMobile classes="profile-edit-modal mobile" closeHandler={this.props.closeBookDialog} dialogName={StM.DialogNames.UserEdit}>
                    <div className="modal-dialog-header">
                        <div className="title">My Profile</div>
                    </div>
                    <div className="modal-dialog-body profile-edit">
                        <div className="modal-dialog-body-content ">
                            <div className="form-wrapper">
                                <div className="inputs-wrapper">
                                    <Field name="firstName"
                                        type="text"
                                        label="First Name"
                                        error={this.state.errors && this.state.errors.firstName}
                                        maxLength={32}
                                        value={profile.firstName}
                                        onFieldChange={(name, value) => this.handleFieldChange(name, value)}
                                    />
                                    <Field name="lastName"
                                        type="text"
                                        label="Last Name"
                                        error={this.state.errors && this.state.errors.lastName}
                                        maxLength={32}
                                        value={profile.lastName}
                                        onFieldChange={(name, value) => this.handleFieldChange(name, value)}
                                    />
                                    <Field name="dateOfBirth" className='date-of-birth' label="Date of Birth" error={this.state.errors && this.state.errors.dateOfBirth}>
                                        <DatePickerMobile classes="input-item date-of-birth"
                                            date={profile.dateOfBirth}
                                            disabled={!!this.props.user.dateOfBirth && this.utils.checkIsBirthdayUnderage(this.props.user.dateOfBirth, this.props.club)}
                                            onChange={(date) => this.handleFieldChange('dateOfBirth', this.utils.toDateOfBirth(date))}
                                        />
                                    </Field>
                                    <Field name="email"
                                        type="email"
                                        label="Email"
                                        error={this.state.errors && this.state.errors.email}
                                        maxLength={128}
                                        autoComplete="off"
                                        value={profile.email}
                                        onFieldChange={(name, value) => this.handleFieldChange(name, value)}
                                    />
                                    <Field name="phone" label="Phone" error={this.state.errors && this.state.errors.phone}>
                                        <PhoneInput
                                            value={profile.phone}
                                            preferredCountries={['us']}
                                            defaultCountry="us"
                                            onChange={(value) => { this.handleFieldChange('phone', value) }}
                                            placeholder="+1 (111) 111 1111"
                                        />
                                    </Field>
                                    <Field name="gender" label="Gender" error={this.state.errors && this.state.errors.gender}>
                                        <InputSearchMobile
                                            array={this.sex}
                                            placeholder=" "
                                            classes="sex-input-wrapper"
                                            selected={sex}
                                            readOnly
                                            onSelectChange={(item) => this.handleFieldChange('gender', item.value)}
                                        />
                                    </Field>
                                    <Field name="skill" label="Skill" error={this.state.errors && this.state.errors.skill}>
                                        <InputSearchMobile
                                            array={this.skills}
                                            placeholder=" "
                                            classes="skill-input-wrapper"
                                            selected={skill}
                                            readOnly
                                            onSelectChange={(item) => this.handleFieldChange('skill', item.value)}
                                        />
                                    </Field>
                                    {this.renderEmergencyContactForm()}
                                    <div className="input-item checkbox-available">
                                        <div className="checkbox-wrapper">
                                            <label className="available-invite">
                                                <input type="checkbox" hidden checked={profile.isAvailableForInvitation} onChange={(e: any) => this.handleFieldChange('isAvailableForInvitation', e.target.checked)} />
                                                <span>{Strings.AvailableForInvitationTitle}</span>
                                            </label>
                                            <div className="news-description">{Strings.AvailableForInvitationExplanation}</div>
                                        </div>
                                    </div>
                                    <div className="input-item squash-news-item">
                                        <label className="squash-news">
                                            <input type="checkbox" hidden checked={profile.newsletterSubscribe} onChange={(e: any) => this.handleFieldChange('newsletterSubscribe', e.target.checked)} />
                                            <span>{Strings.getReceiveNewsTitle(this.props.club)}</span>
                                        </label>
                                    </div>
                                </div>
                                <FormError errors={this.state.errors} />
                            </div>
                        </div>
                        <div className="btns-wrapper modal-dialog-body-content">
                            <button className="btn-next btn-red btn-mobile" onClick={(e) => this.handleOnSaveClick(e)} >Save</button>
                        </div>
                    </div>
                </ModalMobile>
            );
        } else {
            return null;
        }
    }

    private renderEmergencyContactForm() {
        const name = this.state.profile.emergencyContactFullName;
        const phone = this.state.profile.emergencyContactPhoneNumber;
        const relationship = this.state.profile.emergencyContactRelationship;

        return (
            <div>
                <div className="title">Emergency contact information</div>
                <Field name="emergencyContactFullName"
                    label="Name"
                    type="text"
                    maxLength={128}
                    value={name}
                    error={this.state.errors && this.state.errors.emergencyContactFullName}
                    onFieldChange={(name, value) => this.handleFieldChange(name, value)}
                />
                <Field name="emergencyContactPhoneNumber" label="Phone" error={this.state.errors && this.state.errors.emergencyContactPhoneNumber}>
                    <PhoneInput
                        value={phone}
                        preferredCountries={['us']}
                        defaultCountry="us"
                        onChange={(value) => { this.handleFieldChange('emergencyContactPhoneNumber', value) }}
                        placeholder="+1 (111) 111 1111"
                    />
                </Field>
                <Field name="emergencyContactRelationship"
                    label="Relationship"
                    type="text"
                    maxLength={128}
                    value={relationship}
                    error={this.state.errors && this.state.errors.emergencyContactRelationship}
                    onFieldChange={(name, value) => this.handleFieldChange(name, value)}
                />
            </div>
        );
    }

    private closeClick(e: any) {
        if (e) { e.stopPropagation(); }
        this.props.closeBookDialog();
    }

    private handleFieldChange(name: string, value: any) {
        let errors = !!this.state.errors && { ...this.state.errors };
        if (errors) delete errors[name];
        this.setState({
            profile: {
                ...this.state.profile,
                [name]: value
            },
            errors
        });
    }

    private handleOnSaveClick(e: any) {
        if (e) { e.stopPropagation(); }

        const validateBirthdate = !this.props.user.dateOfBirth || !this.utils.checkIsBirthdayUnderage(this.props.user.dateOfBirth, this.props.club);
        const errors = this.formValidator.validateEditUserProfileForm(this.state.profile, this.props.club, validateBirthdate);
        if (this.validator.hasErrors(errors)) {
            this.setState({ ...this.state, errors });
            return false;
        }

        this.props.showSpinner();
        if (this.state.errors) delete this.state.errors.server;

        const savedProfile = {...this.state.profile};

        if(this.props.user.dateOfBirth && this.utils.checkIsBirthdayUnderage(this.props.user.dateOfBirth, this.props.club)){
            savedProfile.dateOfBirth = null;
        }
        else {
            savedProfile.dateOfBirth = savedProfile.dateOfBirth.startOf('day');
        }

        this.props.save(savedProfile)
            .then(() => {
                this.props.hideSpinner();
                this.props.closeBookDialog();
            }).catch((error) => {
                this.props.hideSpinner();
                this.props.closeAlert();
                if (this.state.errors) this.setState({ profile: this.getProfile(this.props.user), errors: { ...this.state.errors, server: error, userName: error } });
                else this.setState({ profile: this.getProfile(this.props.user), errors: { server: error, userName: error } });
            });
    }
}

const mapStateToProps = (state: StM.IGlobalStoreState, ownProps: any) => {
    return {
        isShown: state.dialogs.userEdit.isOpened
        , user: state.user
        , club: state.club
        , isAuth: state.app.isAuthorized
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        closeBookDialog: () => dispatch(ActM.DialogActions.close(StM.DialogNames.UserEdit))
        , save: (profile: StM.IUserManagableStoreState) => dispatch(ActM.UserEditDialogActions.save(profile))
        , showSpinner: () => dispatch(ActM.AppActions.showSpinner())
        , hideSpinner: () => dispatch(ActM.AppActions.hideSpinner())
        , closeAlert: () => dispatch(ActM.DialogActions.close(StM.DialogNames.Alert, null, true))
    };

}

export default connect(mapStateToProps, mapDispatchToProps)(EditUserMobile);